// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"x_sy h_jm h_fm h_fq h_fB h_dJ h_t","menuItemSub":"x_sz h_dQ h_fm h_fB","menuMainLink":"x_sB h_jn h_hh","menuLink":"x_sC h_jn h_hh","Link":"x_q7 p_q7 p_qp p_qK"};